import React from 'react'
import SarasTooltip from '../../../library/notifications/SarasTooltip';
import * as fn from "../../../helper/uiFunctions";

//starting with capital letter will ensure this is treated as a component
const InvGridItemWPD = ({formObject, viewData, rowKey, imgHeight}) => {

    return (
        <div className="saras-cell">
            <ul className="uiSearchSubList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sItemCode uiCenter">{row.rowValues.itemCode.valF}</span>

                        {
                        !fn.compareNumber(row.rowValues.itemImage.dataList.isHid, 1) ?
                        <span className="sItemID uiCenter">
                            <SarasTooltip title={row.rowValues.itemDetail.valF || ''}>
                                <span style={{display:"inline-block",width:"50px",height:"50px"}}>
                                    <a href={row.rowValues.itemImage.dataList.lsrc} target="_LargeImage">
                                        <img alt="" height={imgHeight || "100%"} width="100%" src={row.rowValues.itemImage.dataList.src} />
                                    </a>
                                </span>
                            </SarasTooltip>
                        </span>
                        :
                        <span className="sItemID uiCenter">{row.rowValues.itemDetail.valF}</span>
                        }
                        <span className="sItemWeight uiCenter">{row.rowValues.itemQty.valF}</span>
                        <span className="sItemWeight uiCenter">{row.rowValues.itemCost.valF}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default InvGridItemWPD
